const LOCALES = {
  EN_CN: 'en-CN',
  FR_CA: 'fr-CA',
  PT_BR: 'pt-BR',
  ZH_CN: 'zh-CN',
  FR_FR: 'fr-FR',
  RU_RU: 'ru-RU',
  UK_UA: 'uk-UA',
  IT_IT: 'it-IT',
};

const LOCALES_TO_DISPLAY_DIDOMI = [LOCALES.FR_FR];

export { LOCALES, LOCALES_TO_DISPLAY_DIDOMI };
